/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_File_Read_SuccessInputs */

const es_tools_nexata_file_read_success = /** @type {(inputs: Tools_Nexata_File_Read_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo leído`)
};

const en_tools_nexata_file_read_success = /** @type {(inputs: Tools_Nexata_File_Read_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File read`)
};

/**
* | output |
* | --- |
* | "File read" |
*
* @param {Tools_Nexata_File_Read_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_file_read_success = /** @type {((inputs?: Tools_Nexata_File_Read_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_File_Read_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_file_read_success(inputs)
	return en_tools_nexata_file_read_success(inputs)
});
export { tools_nexata_file_read_success as "tools.nexata.file_read_success" }